import React, { useState } from 'react';
// Context
import { useCTALogTypesData } from '../../../../context/CTALogTypesContext';
// Modules
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FaPencilAlt } from 'react-icons/fa';
// Components
import DefaultTable from '../../../../components/table/DefaultTable';
import { Column } from '../../../../components/table/components/Types';
import DefaultModal from '../../../../components/modal/DefaultModal';
import CTALogTypeForm from './CTALogTypeForm';
// Icons
import { FaPlus } from 'react-icons/fa6';

const CTALogTypesTable = () => {
  // Context
  const { state, dispatch } = useCTALogTypesData();

  // State
  const [showModal, setModalShow] = useState(false);
  const [CTALogType, setCTALogType] = useState(null);

  // Methods
  const handleShowModal = () => setModalShow(true);

  const handleCloseModal = () => setModalShow(false);

  const handleEditCTALogType = (item) => {
    setCTALogType(item);
    handleShowModal();
  };

  const handleCreateCTALogType = () => {
    setCTALogType(null);
    handleShowModal();
  };

  const handleSort = (accessor) => {
    dispatch({
      type: 'SET_SORT',
      payload: {
        type: !state.sort.type || state.sort.type === 'desc' ? 'asc' : 'desc',
        accessor: accessor,
      },
    });
  };

  return (
    <>
      <Row className="my-3">
        <Col className="cta--table-title">
          <h6>Objectos</h6>
        </Col>
        <Col className="text-end">
          <Button onClick={handleCreateCTALogType}>
            <FaPlus /> Objecto
          </Button>
        </Col>
      </Row>
      <DefaultTable data={state.data} isLoading={state.loading}>
        <Column header={'Nome'} accessor="name" sorting={{ sort: state.sort, apply: handleSort }} />
        <Column
          header={'Ações'}
          headerClass={'width-1'}
          render={(value, row) => {
            return (
              <div className="table--action">
                <span onClick={() => handleEditCTALogType(row)}>
                  <FaPencilAlt />
                </span>
              </div>
            );
          }}
        />
      </DefaultTable>
      <DefaultModal
        title={CTALogType && CTALogType.id !== 0 ? 'Editar objecto' : 'Novo objecto'}
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      >
        <CTALogTypeForm CTALogType={CTALogType} handleCloseModal={handleCloseModal} />
      </DefaultModal>
    </>
  );
};

export default CTALogTypesTable;
